<template>
<div id="app">
  <div class="color"></div>
  <div class="color"></div>
  <div class="color"></div>


  <el-row type="flex" align="middle" justify="center" >
    <el-col :span="24">
      <el-row type="flex" align="middle" justify="center">
        <el-col>
          <div style="height:100%; margin-bottom: 100%">
            <div style="font-size:20px; text-align: center; height:100%">
              星星哎
            </div>
            <div style="text-align: center">
              AI宇宙里的一颗小星星
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="14">
        <el-col :span="12">
          <AIList/>
        </el-col>
        <el-col :span="12">
          <div style="width:300px" id="about">
            <a href="https://github.com/Halle-Astra" >
              关于站长
            </a>
          </div>
        </el-col>
      </el-row>
    </el-col>
  </el-row>
    <div class="f_bq" >
      <!-- 版权内容请在本组件"内容配置-版权"处填写 -->
      <p>Copyright © 版权所有：星星哎/王精东 &nbsp;
        <a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2024222613号</a>
      </p>
    </div>
</div>
</template>

<script>
import AIList from "./components/AIList.vue"
export default {
  name: 'App',
  components: {
    AIList
  },

}
</script>

<style scoped>

img{
  height:100%;
  width: 100%;
}





// https://zhuanlan.zhihu.com/p/671162057
#app::before {
            content: "";
            position: absolute;
            bottom: 0px;
            width: 100%;
            height: 100%;
            z-index: 1;
            border-top: 1px solid rgba(255, 255, 255, 0.5);
            /* 背景模糊 */
            backdrop-filter: blur(5px);
            overflow:hidden;
        }

#app .color {
            position: absolute;
            /* 模糊滤镜 数值越大越模糊 */
            filter: blur(200px);
        }

#app .color:nth-child(1) {
            background: #fd746c;
            width: 100%;
            z-index:-1;
            /*height:100%;*/
            /*width: 800px;*/
            /*height: 800px;*/
            /*top: -450px;*/
        }

#app .color:nth-child(2) {
            background: #cf8bf3;
            bottom: -150px;
            left: 100px;
        }

#app .color:nth-child(3) {
            background: #fdb99b;
            width: 400px;
            height: 400px;
            bottom: 50px;
            right: 100px;
            z-index: -1;
        }

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: black;
  margin:auto;
  display: flex;
  width: 100%;
  height:100%;
  //background-color: bisque;
  flex-direction: column;
  //justify-content: space-between;
  align-items: center;
}



body > div {
  height: 100%;
}

.el-col{
  //height:100%;
}

.el-row{
  width:100%;
  display: flex;
  height: 100%;
  align-content: stretch;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/App.vue